/* eslint-disable no-unused-vars */
import { useInfiniteQuery } from 'react-query'

import { getViewLikesUsersList } from 'services/endpoints/post'
import { type SortDirection } from 'types/enums'

export const useGetViewLikesUsers = (
    postId: string,
    sortDirection: SortDirection,
    searchTerm: string,
    enabled: boolean = true
) => {
    return useInfiniteQuery(
        ['viewerLikes', postId, sortDirection, searchTerm],
        async ({ pageParam = 1 }) => {
            return await getViewLikesUsersList(
                postId,
                sortDirection,
                pageParam,
                searchTerm
            )
        },
        {
            enabled,
            getNextPageParam: lastPage => {
                if (
                    lastPage?.data?.pagination?.current_page *
                        lastPage?.data?.pagination?.per_page <
                    lastPage?.data?.pagination?.total
                ) {
                    return lastPage?.data?.pagination?.current_page + 1
                }
                return false
            },
            refetchOnWindowFocus: false,
            staleTime: 10000
        }
    )
}